import OwnerProfile from './OwnerProfile.vue';

export default OwnerProfile;
